module.exports = __webpack_public_path__ + "static/media/circle_arrows.9982d511.svg";